import { Link } from 'react-router-dom'
import {access} from './function/constans'

function Access() {
    return (
        <div className='fw-bold alert alert-danger border-0 text-center py-5'>
            <p>{access}</p>
            <a 
                href={'/dashboard'}
                className='btn btn-danger px-3'>
                بازگشت به صفحه اصلی
            </a>
        </div>
    )
}

export default Access;